/**
 * A helper function to decide the current env, ie browser/server.
 * @return {Boolean} true/false
 */
export const isServer = () => {
  return __SERVER__ === true // eslint-disable-line
}

/**
 * A helpful funciton to decide the current env, ie production/development
 * @return {Boolean} true/false
 */
export const isProduction = () => {
  return process.env.NODE_ENV === 'production'
}

export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development'
}



// WEBPACK FOOTER //
// ./common/utils/envHelper.js